import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "yfatzmuu",
  dataset: "production",
});
